import { useAppDispatch } from "@/core/app/hooks"
import { useTheme } from "@mui/material/styles"
import type { FC } from "react"
import {
  Box,
  Button,
  IconButton,
  Typography,
} from "../../../components/mui.components"

import CloseSvg from "../../assets/modeltools/RedXMark.svg"

interface Type {
  ClickUndo?: () => void
  ClickReset?: () => void
  ClickClose?: (e) => void
  DoShowClose?: boolean
}

const RegistrationTools: FC<Type> = ({
  ClickUndo,
  ClickReset,
  ClickClose,
  DoShowClose,
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const buttonNames = ["Undo", "Reset"]

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          position: "absolute",
          top: "250px",
          right: "1%",
          width: "130px",
          height: "500px",
          borderRadius: 2,
          flexDirection: "column",

          //bgcolor: theme.transBkColor.light
        }}
      >
        <Box
          sx={{
            display: "flex",
            right: "2%",
            width: "250px",
            height: "70px",
            borderRadius: 2,
            flexDirection: "row",
            alignItems: "center",
            //bgcolor: theme.transBkColor.light
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              width: "100%",
              height: "70px",
              borderRadius: 2,
              flexDirection: "column",
              marginRight: "20px",

              //bgcolor: theme.transBkColor.light
            }}
          >
            <Typography variant="h5" color="#FFFFFF">
              Check Bite
            </Typography>
            <Typography variant="h5" color="#FFFFFF">
              Registration
            </Typography>
          </Box>

          {DoShowClose && (
            <Box
              sx={{
                display: "flex",
                alignItems: "column",
                width: "35px",
                height: "45px",
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "35px",
                  height: "35px",
                  borderRadius: 100,
                  backgroundColor: "#FF632B",
                  "&:hover": { background: "#FF632B" },
                }}
                onClick={ClickClose}
              >
                <img
                  src={CloseSvg}
                  style={{ height: "18px", width: "18px" }}
                ></img>
              </IconButton>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            width: "65px",
            // height: "153px",
            // borderRadius: 2,
            flexDirection: "column",
            marginRight: "5px",
            // paddingTop: "49px",
            // backgroundColor: theme.transBkColor.light,
          }}
        >
          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              padding: "0px 0px",
              flexWrap: "wrap",
              border: "none",
              borderRadius: "0px",
              backgroundColor: "#f9f9f9",
              "&:hover": {
                backgroundColor: "#f9f9f9",
              },
              borderBottom: "1px solid",
              borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
            }}
            onClick={(e) => {
              if (ClickUndo) ClickUndo()
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              {buttonNames[0]}
            </Typography>
          </Button>

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              padding: "0px 0px",
              flexWrap: "wrap",
              border: "none",
              borderRadius: "0px",
              backgroundColor: "#f9f9f9",
              "&:hover": {
                backgroundColor: "#f9f9f9",
              },
            }}
            onClick={(e) => {
              if (ClickReset) ClickReset()
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              {buttonNames[1]}
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  )
}
export default RegistrationTools
